module.exports = __webpack_public_path__ + "static/media/logo.8be773bf.png";